var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMaskito } from "@maskito/react";
import { TextField } from "@opala-ds/react";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useGetAddressByCep } from "../../queries/via-cep";
import { cepMask } from "../../utils/masks";
export function CepField(_a) {
    var _b, _c;
    var defaultValue = _a.defaultValue;
    var _d = useFormContext(), watch = _d.watch, setValue = _d.setValue, setError = _d.setError, register = _d.register, resetField = _d.resetField, clearErrors = _d.clearErrors, errors = _d.formState.errors;
    var cepValue = watch("cep");
    var cepMaskRef = useMaskito({ options: cepMask });
    var _e = useGetAddressByCep(cepValue), getAddressByCepResult = _e.data, isFetching = _e.isFetching;
    useEffect(function () {
        if (defaultValue)
            return;
        if (!getAddressByCepResult)
            return;
        var hasEligibleUf = getAddressByCepResult.data.uf === "PI" ||
            (getAddressByCepResult.data.uf === "MA" &&
                getAddressByCepResult.data.localidade === "Timon");
        if (!hasEligibleUf) {
            setError("cep", {
                message: "Localidade não permitida",
                type: "validate",
            });
            resetField("bairro");
            resetField("uf");
            resetField("logradouro");
            resetField("complemento");
            resetField("municipio");
            return;
        }
        clearErrors("cep");
        setValue("bairro", getAddressByCepResult.data.bairro);
        setValue("uf", getAddressByCepResult.data.uf);
        setValue("logradouro", getAddressByCepResult.data.logradouro);
        setValue("complemento", getAddressByCepResult.data.complemento);
        setValue("municipio", getAddressByCepResult.data.localidade);
    }, [
        clearErrors,
        defaultValue,
        getAddressByCepResult,
        resetField,
        setError,
        setValue,
    ]);
    return (_jsx(TextField, __assign({ label: "CEP", type: "text" // ← deixa Maskito funcionar
        , inputMode: "numeric" // ← exibe teclado numérico no mobile
        , 
        // pattern="\d*" // ← opcional: aceita só dígitos
        placeholder: "Digite o CEP do seu endere\u00E7o", autoComplete: "postal-code", size: "md", helperText: (_c = (_b = errors.cep) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: errors.cep ? "critical" : "default", disabled: isFetching }, register("cep"), { ref: function (node) {
            cepMaskRef(node);
            register("cep").ref(node);
        } })));
}
